import { EffectsMapObject } from "dva";
import { ReducersMapObject } from "redux";
import { freeze } from "immer";
import { CoreEffects, CoreState, CoreReducers, getLocalStorage } from "@reco-m/core";
import { app } from "@reco-w/core-ui";

import { notificationSceneService, notificationService } from "@reco-w/notice-service";
import { MailBoxTypeEnum, Namespaces, NotificationTypesEnum, SceneCode } from "./common";

export namespace noticeCommonModel {
    export const namespace = Namespaces.noticeCommon;

    let sceneIds: any[] = [];

    export const state: any = freeze(
        {
            ...CoreState,
        },
        !0
    );

    export type StateType = typeof state;

    export const reducers: ReducersMapObject = {
        ...CoreReducers,

        initState() {
            return state;
        },
    };

    export const effects: EffectsMapObject = {
        ...CoreEffects,

        /**
         * 获取消息
         * @param { message }
         * @param { call, put, select }
         */
        *getUnreadNotification({ message }, { call, put, select }) {
            try {
                yield yield put({ type: `${Namespaces.memberCommon}/getCurrentUser`, message });
                const memberCommonState = yield select((state) => state[Namespaces.memberCommon]),
                    user = memberCommonState!.user,
                    currentUser = user && user!.currentUser;

                if (!currentUser) {
                    return;
                }

                if (!sceneIds?.length) {
                    let selfSceneId: any[] = [];
                    const allNotificationScene = yield call(notificationSceneService.getAllScene, { productCode: "IPARK" });

                    allNotificationScene.forEach((item) => {
                        if (SceneCode.includes(item.sceneCode)) {
                            selfSceneId.push(item.id);
                        }
                    });

                    sceneIds = selfSceneId;
                }

                const result = yield call(notificationService.getPaged, {
                    ownerId: currentUser.id,
                    isRead: false,
                    notificationType: NotificationTypesEnum.unRead,
                    mailbox: MailBoxTypeEnum.mailBox2,
                    parkId: getLocalStorage("parkId"),
                    sceneId: sceneIds,
                    pageSize: 1,
                });

                yield put({ type: "input", data: { notice: result, noticeCount: result.totalItems } });
            } catch (e) {
                yield call(message!.error, "getNotification：" + e.errmsg);
            }
        },
    };
}

app.model(noticeCommonModel);
